export default __webpack_public_path__ + "static/media/ps.cd041b9c.svg";